import { Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import { Formik, FieldArray, FormikHelpers } from "formik";
import { OUTCOMES } from "../../../constants";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

interface Values {
  properties: any;
}

export const AdditionalProperty = (): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      properties: [],
    },
  };

  const handleSubmit = (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");

    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        OUTCOMES.complete,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title="Where else did [Jacob] own property?"
      subTitle="Secondary residences, rental property, and the like are typically referred to as an ancillary estate."
    >
      <Formik initialValues={formikInit.values} onSubmit={handleSubmit}>
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <FieldArray
              name="properties"
              render={(arrayHelpers) => (
                <Grid
                  container
                  spacing={1}
                  sx={{
                    my: 2,
                  }}
                >
                  {values.properties.length > 1 ? (
                    values.properties.map((property, index) => (
                      <Grid key={index} item xs={12}>
                        <Typography variant="body1">
                          Ancillary Estate #{index + 1}
                        </Typography>
                        <TextField
                          error={Boolean(
                            touched.properties && errors.properties
                          )}
                          fullWidth
                          helperText={touched.properties && errors.properties}
                          label="Address"
                          margin="normal"
                          name={`properties.${index}`}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="text"
                          value={values.properties[index]}
                          variant="outlined"
                        />
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        Ancillary Estate #1
                      </Typography>
                      <TextField
                        error={Boolean(touched.properties && errors.properties)}
                        fullWidth
                        helperText={touched.properties && errors.properties}
                        label="Address"
                        margin="normal"
                        name={`properties.0`}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="text"
                        value={values.properties[0]}
                        variant="outlined"
                      />
                    </Grid>
                  )}
                  <div>
                    <button
                      style={{
                        border: "none",
                        background: "none",
                        paddingTop: "8px",
                        paddingLeft: "8px",
                        marginTop: "24px",
                        marginBottom: "24px",
                      }}
                      onClick={(event) => {
                        event.preventDefault();

                        if (
                          values.properties[values.properties.length - 1] === ""
                        ) {
                          // empty address
                        } else {
                          arrayHelpers.insert(values.properties.length, "");
                        }
                      }}
                    >
                      <Typography variant="body1">
                        Add another property
                      </Typography>
                    </button>
                  </div>
                </Grid>
              )}
            />
            <ScreenFlowFormButtons
              isSubmitting={isSubmitting}
              status={status}
              onBack={() => navigate(-1)}
            />
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
